<div mat-dialog-title>
  <div>CHANGE APPLICANT</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>
    Current Applicant:
    <span class="current-applicant">{{ data.currentApplicant.getDisplayName() }}</span>
  </p>
  <form [formGroup]="changeApplicantForm">
    <span class="change-to">Change to:</span>
    <mat-form-field class="change-applicant-select">
      <input type="text" placeholder="New Applicant" matInput
             formControlName="newApplicant"
             [matAutocomplete]="auto"
             autocomplete="off"
             data-lpignore="true"
      />
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="
                 filteredUser=$event.option.value; selectedUser.setValue($event.option.value.getDisplayName())
                ">
        @if (isLoading) {
          <mat-option class="is-loading">Loading...</mat-option>
        } @else if (!isLoading && usersList?.length == 0) {
          <mat-option [disabled]="true" class="is-loading">User not found</mat-option>
        } @else {
          @for (user of usersList; track user) {
            <mat-option [value]="user">
              {{ user.getDisplayName({ includeEmail: true }) }}
            </mat-option>
          }
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button data-cy="button-cancel" mat-stroked-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button
    data-cy="button-submit"
    mat-raised-button
    color="primary"
    [disabled]="!changeApplicantForm.valid"
    (click)="onSubmit()">
    Submit
  </button>
</div>
